
import { Brain, Download, Search } from 'lucide-react';
import { DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

interface ModalHeaderProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  onExpandAll: () => void;
  onCollapseAll: () => void;
  onDownload: () => void;
}

export default function ModalHeader({
  searchTerm,
  onSearchChange,
  onExpandAll,
  onCollapseAll,
  onDownload
}: ModalHeaderProps) {
  return (
    <>
      <DialogHeader>
        <DialogTitle className="flex items-center space-x-2">
          <Brain className="h-6 w-6 text-purple-600" />
          <span>Relatório Ultra-Detalhado - Modelo o3</span>
          <Badge variant="outline" className="ml-2 bg-gradient-to-r from-purple-100 to-blue-100">
            IA Avançada
          </Badge>
        </DialogTitle>
      </DialogHeader>

      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center space-x-4">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
            <Input
              placeholder="Buscar no relatório..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              className="pl-10 w-64"
            />
          </div>
          <Badge variant="secondary" className="bg-green-100 text-green-800">
            Modelo o3 • 50 Seshs
          </Badge>
        </div>
        <div className="flex items-center space-x-2">
          <Button
            onClick={onExpandAll}
            variant="outline"
            size="sm"
          >
            Expandir Tudo
          </Button>
          <Button
            onClick={onCollapseAll}
            variant="outline"
            size="sm"
          >
            Minimizar Tudo
          </Button>
          <Button
            onClick={onDownload}
            variant="default"
            size="sm"
            className="bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white shadow-lg"
          >
            <Download className="mr-2 h-4 w-4" />
            Baixar PDF
          </Button>
        </div>
      </div>
    </>
  );
}
